import React from 'react';
import type { HomeDashboard } from '../../../api/homeV3Api';
import { formatDate } from '../utils/formatters';
import styles from '../HomeV3.module.css';

interface Props { exercises: HomeDashboard['exercises']; }

export function ExercisePanel({ exercises }: Props) {
    return (
        <section id="targeting-exercises" className={`${styles.panel} ${styles.exercisePanel}`} tabIndex={-1} aria-labelledby="exercise-heading">
            <div className={styles.panelHeader}>
                <div>
                    <p className={styles.eyebrow}>Targeting</p>
                    <h2 id="exercise-heading">Active exercises</h2>
                </div>
                <span className={styles.status}>{exercises.length} active</span>
            </div>
            {exercises.length === 0 ? (
                <div className={styles.emptyState}><p className={styles.muted}>No active targeting exercises are available.</p></div>
            ) : (
                <div className={styles.exerciseList}>
                    {exercises.map((exercise) => {
                        const percent = Math.min(100, Math.round((exercise.progressCurrent / exercise.progressTotal) * 100));
                        return (
                            <article key={exercise.id} className={styles.exerciseCard}>
                                <strong>{exercise.name}</strong>
                                <p className={styles.muted}>{formatDate(exercise.startDateUtc)} – {formatDate(exercise.endDateUtc)}</p>
                                <div className={styles.progressTrack} aria-hidden="true"><div className={styles.progressFill} style={{ width: `${percent}%` }} /></div>
                                <p className={styles.muted}>{percent}% of schedule elapsed</p>
                                <a className={styles.primaryButton} href={exercise.destination}>Open exercise</a>
                            </article>
                        );
                    })}
                </div>
            )}
        </section>
    );
}
